export default {
  setVeiculos({ commit }, payload) {
    commit('setVeiculos', payload)
  },

  setSelectedVeiculo({ commit }, payload) {
    commit('setSelectedVeiculo', payload)
  }
}
